<template>
  <div>
    <LayoutSection size="o5v90">
      <el-link class="logout-btn mt-50" :underline="true" @click="handleLogout">
        {{ $t("users.account.logout") }}
      </el-link>
      <h2 class="mb-13 text-left account-title mt-50 text-uppercase">
        {{ $t("users.account.title") }}
      </h2>
      <div :class="isMobileLayout ? '' : 'my-account-sec'">
        <el-col class="text-left account-tile" :xs="24" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15 account-img-section" @click="goTo('/account/sales')">
            <img :src="salesImage" class="account-profile-image" />
          </div>
          <div class="account-tile-desscription">
            <span class="account-tile-title">{{
              $t("users.account.salesHistoricTitle")
              }}</span>
            <p class="mt-10">
              {{ $t("users.account.salesHistoricDescription") }}
            </p>
            <el-link class="mt-10 read-more" :underline="false" @click="goTo('/account/sales')">
              {{ $t("users.account.consultSalesHistoric") }}
            </el-link>
          </div>
        </el-col>
        <el-col class="text-left account-tile" :xs="24" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15 account-img-section" @click="goTo('/account/profile')">
            <img :src="profileImage" class="account-profile-image" />
          </div>
          <div class="account-tile-desscription">
            <span class="account-tile-title">{{
              $t("users.account.profileTitle")
              }}</span>
            <p class="mt-10">{{ $t("users.account.profileDescription") }}</p>
            <el-link class="mt-10 read-more" :underline="false" @click="goTo('/account/profile')">
              {{ $t("users.account.consultMyProfile") }}
            </el-link>
          </div>
        </el-col>
        <el-col class="text-left account-tile subscription" :xs="24" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15 account-img-section" @click="goTo('/subscriptions')">
            <img :src="subscriptionImage" class="account-profile-image" />
          </div>
          <div class="account-tile-desscription">
            <span class="account-tile-title">{{
              $t("users.account.subscriptionTitle")
              }}</span>
            <p class="mt-10">{{ $t("users.account.subscriptionDescription") }}</p>
            <el-link class="mt-10 read-more" :underline="false" @click="goTo('/subscriptions')">
              <!-- Note: Disable link temporary -->
              {{ $t("users.account.consultsubscription") }}
            </el-link>
          </div>
        </el-col>
      </div>
      <el-col>
        <div class="mt-100 mb-50 home-carousel-product account-page-carousel">
          <h3 class="text-left text-uppercase mb-30 suggestions">
            {{ $t("users.suggestions") }}
          </h3>
          <ProductCarousel id="product-cards-list-similar" :products="getCarouselProducts()" :tax-code="actionBar && actionBar.tax" arrow="always"
            class="product-carousel" />
          <div class="text-left mt-10 mr-0">
            <router-link :to="productsView" :class="[
              'el-link el-link--primary is-underline',
              isMobileLayout ? 'all-products__mobile' : '',
            ]">
              <span class="el-link--inner">
                {{ ctaAllProducts }}
              </span>
            </router-link>
          </div>
        </div>
      </el-col>
    </LayoutSection>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LayoutSection from "@/components/layout/layout-section.vue";
import ProductCarousel from "../product/components/product-carousel.vue";
import layoutUtils from "@/utils/layout-utils";
import { getDefaultAvailability } from "@/utils/market-utils";
import { sortByHierarchyWithAlternation } from "@/utils/carousel-sort-utils";
import goTo from "../../mixins/goTo";
export default {
  mixins: [goTo],
  components: {
    LayoutSection,
    ProductCarousel,
  },
  props: {},
  data() {
    return {
      productBtnLinkWidth: this.$i18n.locale == "en-US" ? "" : "147px",
    };
  },
  computed: {
    ...mapState("product", ["products", "filters", "carousel"]),
    productsView() {
      return {
        name: "products",
        params: {},
      };
    },
    ctaAllProducts() {
      return this.$i18n.t("home.homeView.productCarousel.allProducts");
    },
    salesImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/sales-historic.png");
    },
    profileImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/profile.png");
    },
    subscriptionImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/subscriptions.png");
    },
    ...mapState("configuration", ["actionBar"]),
    similarProductsLabel() {
      return this.$i18n.t("products.productView.label.similarProducts");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    getCarousel() {
      return this.carousel && this.carousel.products;
    },
  },
  created() {
    let filters = {
      availability: ["IP", "SAQ"],
    };
    this.fetchProducts({ filters });
  },
  watch: {
    products(val) {
      if (!val || !val.results) return;
      const market = localStorage.getItem("countryCode") || "QC";
      const allowedCodes = getDefaultAvailability(market).map(c => c.toUpperCase());
      val.results.forEach((e) => {
        if (e.productInventories) {
          let price = e.productInventories.find((r) =>
            r.id == e.id && allowedCodes.indexOf(r.inventory.code.toUpperCase()) !== -1
          );
          if (price) {
            e.erpProduct = price;
            e.inventory = price.inventory;
            e.pricing = price.pricing;
          }
        }
      });
    },
  },
  mounted() {
    this.getProductCarouselProduct();
    this.$root.$on("chanLang", () => {
      this.productBtnLinkWidth =
        this.$i18n.locale == "en-US" ? "102px" : "147px";
    });
    this.$root.$on("chancountryCode", (countryCode) => {
      this.countryCode = countryCode;
      this.getProductCarouselProduct()
    });
  },
  methods: {
    ...mapActions("product", ["fetchProducts", "fetchProductFilters", "fetchCarouselProducts"]),
    ...mapActions("user", ["logout", "createTempUser"]),
    ...mapActions("shoppingCart", ["emptyShoppingCart"]),
    ...mapActions("product", ["fetchProducts"]),
    handleLogout() {
      this.logout();
      this.emptyShoppingCart();
      this.createTempUser();
      this.$router.push("/login");
    },

    getProductCarouselProduct() {
      const countryCode = localStorage.getItem('countryCode') ?? this.countryCode;
      this.fetchCarouselProducts({ group: countryCode == 'ON' ? 'HOME_ON' : 'HOME_QC' }).then(() => {
      });
    },

    getCarouselProducts() {
      if (
        this.getCarousel
      ) {
        const products = this.getCarousel[0].contents.filter(
          (product) => product !== null);
        const market = localStorage.getItem("countryCode") || "QC";
        return sortByHierarchyWithAlternation(products, market);
      }
      return [];
    },
  },
};
</script>

<style>
.account-profile-image {
  height: 174px;
}

.account-tile-desscription {
  margin-top: 10px;
}

.account-tile-title {
  font-size: 18px;
  font-weight: bold;
}

.logout-btn:hover:after {
  border-bottom: 1px solid #a31c25 !important
}

.logout-btn {
  position: relative;
  font-weight: 500;
  float: right;
  font-size: 16px;
  color: #a31c25 !important;
}

.read-more {
  color: #a31c25 !important;
  font-size: 16px;
}

#product-cards-list-similar {
  width: 100%;
}

#product-cards-list-similar .carousel__width {
  width: 100%;
}

.suggestions {
  font-weight: 700;
  color: #000;
  font-size: 24px;
}

.subscription {
  opacity: 1;
}

img {
  pointer-events: unset !important;
}

.account-img-section {
  cursor: pointer;
}

.my-account-sec {
  display: flex;
  gap: 10px;
}
</style>
